/**
 * タブ切り替えUIコンポーネント
 */
export class TabManager {
  private tabButtons: NodeListOf<HTMLElement>
  private tabPanes: NodeListOf<HTMLElement>
  private activeTab: string = 'flow'
  private onTabChangeCallback?: (tabId: string) => void
  
  constructor() {
    this.tabButtons = document.querySelectorAll('.tab-button')
    this.tabPanes = document.querySelectorAll('.tab-pane')
    
    this.setupEventListeners()
  }
  
  /**
   * イベントリスナーを設定
   */
  private setupEventListeners(): void {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const tabId = button.getAttribute('data-tab')
        if (tabId && tabId !== this.activeTab) {
          this.switchTab(tabId)
        }
      })
    })
    
    // キーボードショートカット
    document.addEventListener('keydown', (e) => {
      if (e.ctrlKey || e.metaKey) {
        switch (e.key) {
          case '1':
            e.preventDefault()
            this.switchTab('flow')
            break
          // 変数タブとループ条件タブのショートカットを無効化（機能は保持）
          // case '2':
          //   e.preventDefault()
          //   this.switchTab('variables')
          //   break
          // case '3':
          //   e.preventDefault()
          //   this.switchTab('condition')
          //   break
        }
      }
    })
  }
  
  /**
   * タブを切り替え
   */
  public switchTab(tabId: string): void {
    // ボタンの状態を更新
    this.tabButtons.forEach(button => {
      if (button.getAttribute('data-tab') === tabId) {
        button.classList.add('active')
      } else {
        button.classList.remove('active')
      }
    })
    
    // パネルの表示を切り替え
    this.tabPanes.forEach(pane => {
      if (pane.getAttribute('data-pane') === tabId) {
        pane.classList.add('active')
      } else {
        pane.classList.remove('active')
      }
    })
    
    this.activeTab = tabId
    
    // コールバックを実行
    if (this.onTabChangeCallback) {
      this.onTabChangeCallback(tabId)
    }
    
    // キャンバスのリサイズが必要な場合
    if (tabId === 'flow') {
      window.dispatchEvent(new Event('resize'))
    }
  }
  
  /**
   * 現在のタブを取得
   */
  public getActiveTab(): string {
    return this.activeTab
  }
  
  /**
   * タブ変更時のコールバックを設定
   */
  public setOnTabChangeCallback(callback: (tabId: string) => void): void {
    this.onTabChangeCallback = callback
  }
  
  /**
   * クリーンアップ
   */
  public dispose(): void {
    // イベントリスナーをクリーンアップ
    this.tabButtons.forEach(button => {
      button.replaceWith(button.cloneNode(true))
    })
  }
}